import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Form } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useHistory, useParams } from "react-router-dom";

import { REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL } from "config";

const NewUser = () => {
  const [user, setUser] = useState({
    fullName: "",
    email: "",
    userGroup: "",
  });
  let history = useHistory();
  let { id } = useParams();

  const getUser = async () => {
    try {
      const response = await axios.get(
        `${REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL}/api/admin/users/${id}`
      );
      if (response.status === 200) {
        setUser(response.data.user);
      }
    } catch (error) {
      console.log("error: ", error);
    }
  };

  useEffect(() => {
    getUser(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const submit = async (values, { resetForm }) => {
    try {
      const response = await axios.put(
        `${REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL}/api/admin/users/${id}`,
        values
      );
      if (response.status === 200) {
        resetForm();
        history.push("/admin/users");
      }
    } catch (error) {
      console.log("error: ", error);
    }
  };

  const UserSchema = Yup.object().shape({
    fullName: Yup.string().min(1, "Too Short!").required("Required"),
    email: Yup.string().email("Invalid email address").required("Required"),
    userGroup: Yup.string().min(1, "Too Short!").required("Required"),
  });

  const formik = useFormik({
    initialValues: user,
    validateOnMount: true,
    enableReinitialize: true,
    validationSchema: UserSchema,
    onSubmit: submit,
  });

  const { fullName, email, userGroup } = formik.values;

  return (
    <div>
      <Container>
        <Row>
          <Col xs={{ span: 10, offset: 1 }} md={{ span: 6, offset: 3 }}>
            <div className="page">
              <h1>Update User</h1>
              <Form onSubmit={formik.handleSubmit}>
                <Form.Group controlId="fullName" size="lg">
                  <Form.Label>Full name</Form.Label>
                  <Form.Control
                    type="text"
                    name="fullName"
                    value={fullName}
                    onChange={formik.handleChange}
                    isValid={formik.touched.fullName && !formik.errors.fullName}
                  />
                </Form.Group>
                <Form.Group controlId="email" size="lg">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={email}
                    onChange={formik.handleChange}
                    isValid={formik.touched.email && !formik.errors.email}
                  />
                </Form.Group>
                <Form.Group controlId="userGroup" size="lg">
                  <Form.Label>User Group</Form.Label>
                  <Form.Control
                    as="select"
                    name="userGroup"
                    disabled={true}
                    value={userGroup}
                    onChange={(e) => {
                      console.log("e.target.value", e.target.value);
                      formik.setFieldValue("userGroup", e.target.value);
                    }}
                  >
                    <option value="admin">Admin</option>
                    <option value="editor">Editor</option>
                    <option value="configurator">Configurator</option>
                  </Form.Control>
                </Form.Group>
                <p>Customer: {user.customer?.name}</p>
                <Button
                  block
                  size="lg"
                  type="submit"
                  disabled={Object.keys(formik.errors).length !== 0}
                >
                  Update User
                </Button>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default NewUser;
